module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_location_sola@3x-4ff94ce15f685a82d148955113c5def1.webp";